import httpClient from "httpClient"

const post = (request) => {
    
    const pathname = '/page/convenio'
            
    return httpClient.post(pathname, request)    
}

const convenio = {
    post,
}

export default convenio

